interface ProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

export const ProgressIndicator = ({ currentStep, totalSteps }: ProgressIndicatorProps) => {
  return (
    <div className="space-y-2 mb-6">
      <div className="flex items-center justify-center gap-2">
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div
            key={index}
            className={`h-1 rounded-full transition-all duration-300 ${
              index <= currentStep
                ? 'w-10 bg-primary'
                : 'w-3 bg-muted'
            }`}
          />
        ))}
      </div>
      <p className="text-center text-xs text-muted-foreground">
        Step {currentStep + 1} of {totalSteps}
      </p>
    </div>
  );
};
